import {Request} from 'citrus.plugins.request';

export class VuexCompareRestClient {
	constructor(id, iBlockId) {
		this.id = id;
		this.iBlockId = iBlockId;
		this.request = new Request();

		this.request.setModeModule();

		return this;
	}

	getIBlockId() {
		return this.iBlockId;
	}

	setIBlockId(id = null) {
		this.iBlockId = id;
		return this;
	}

	getId() {
		return this.id;
	}

	setId(id = null) {
		this.id = id;
		return this;
	}

	clean() {
		return this.request
			.setAction('citrus:restsale.api.compare.clean')
			.setData({
				id: this.getId(),
				iBlockId: this.getIBlockId()
			})
			.send()
		;
	}

	remove(productId) {
		return this.request
			.setAction('citrus:restsale.api.compare.remove')
			.setData({
				iBlockId: this.getIBlockId(),
				productId: productId
			})
			.send()
		;
	}

	add() {
		return this.request
			.setAction('citrus:restsale.api.compare.add')
			.setData({
				id: this.getId(),
				iBlockId: this.getIBlockId()
			})
			.send()
			;
	}

	load() {
		return this.request
			.setAction('citrus:restsale.api.compare.getList')
			.setData({iBlockId: this.getIBlockId()})
			.send()
			;
	}
}
